export const efaPersonalDetails = {
  efaPersonalDetails: {
    infoMsg: ' Do you have any requests for changes to your personal details? Please contact our customer service',
  }
};
